import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminDonationsPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        API.get('/api/admin/donations')
            .then(res => setData(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="admin-page"><div className="admin-loading">Loading...</div></div>;

    const donations = data?.donations || [];

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Donations</h1>
            </header>

            <div className="stats-grid">
                <StatCard label="Total Raised" value={formatNaira(data?.total_amount)} />
                <StatCard label="Total Donations" value={data?.total_count} />
                <StatCard label="Raised Today" value={formatNaira(data?.today_amount)} />
                <StatCard label="Donations Today" value={data?.today_count} />
            </div>

            <div className="donations-list">
                {donations.length === 0 && <p className="empty">No donations yet.</p>}
                {donations.map((d) => (
                    <div key={d.id} className="donation-card">
                        <div className="donation-main">
                            <span className="donation-amount">
                                {formatNaira(d.amount, d.currency)}
                            </span>
                            <span className={`badge status-${d.status}`}>{d.status}</span>
                        </div>
                        <p className="donation-donor">
                            {d.full_name || d.email || 'Unknown donor'}
                        </p>
                        <div className="donation-meta">
                            <span>{d.tx_ref}</span>
                            <span>{new Date(d.created_at).toLocaleString()}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function StatCard({ label, value }) {
    return (
        <div className="stat-card">
            <div className="stat-value">{value ?? '—'}</div>
            <div className="stat-label">{label}</div>
        </div>
    );
}

function formatNaira(amount, currency = 'NGN') {
    if (amount === undefined || amount === null) return '—';
    const symbol = currency === 'NGN' ? '₦' : `${currency} `;
    return `${symbol}${Number(amount).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
}